import React from "react";
import { min, max } from "d3-array";

import { Svg } from "./partials/Svg";
import { Group } from "./partials/Group";
import { NumberChart } from "./partials/NumberChart";
import { ChartProps, ChartDatum } from "./Chart";

import { linearRegression } from "../../utils/regression";
import { chartColors } from "../../config/colors";
import { margin } from "../../config/spacing";

import heatDaysData from "./data/heat-days.json";
import heavyRainfallData from "./data/heavy-rainfall.json";

export const HeatRain: React.FC<ChartProps> = ({
  id,
  width = 250,
  height = 400,
  isAnimated = true,
}) => {
  const percentChange = (data: ChartDatum[], xKey = "year", yKey = "value") => {
    const regression = linearRegression(data, xKey, yKey);
    const yMin = regression(min(data, (d) => d[xKey])!);
    const yMax = regression(max(data, (d) => d[xKey])!);
    return Math.round(((yMax - yMin) / Math.abs(yMin)) * 100);
  };

  const absoluteChange = (
    data: ChartDatum[],
    xKey = "year",
    yKey = "value"
  ) => {
    const regression = linearRegression(data, xKey, yKey);
    const yMin = regression(min(data, (d) => d[xKey])!);
    const yMax = regression(max(data, (d) => d[xKey])!);
    return Math.round(yMax - yMin);
  };

  return (
    <Svg id={id} width={width} height={height}>
      <Group transform={`translate(${margin.left}, ${margin.top})`}>
        <Group transform="translate(0, 0)">
          <NumberChart
            id="heat"
            text={`+${absoluteChange(heatDaysData)} Tage`}
            title={"Hitzetage"}
            description={
              "Zunahme der heißen Tage pro\nJahr in Deutschland seit 1960"
            }
            source={"DWD"}
            sourceLink={
              "https://www.umweltbundesamt.de/daten/umweltindikatoren/indikator-heisse-tage"
            }
            infoLink={"https://www.ardalpha.de/klimazahlen-hitzetage-100.html"}
            color={chartColors.orange}
            isAnimated={isAnimated}
          />
        </Group>
        <Group transform={`translate(0, ${height / 2})`}>
          <NumberChart
            id="rain"
            text={`+${percentChange(heavyRainfallData)} %`}
            title={"Unwetter"}
            description={
              "Zahl der Starkregenereignisse\nin Deutschland seit 2001"
            }
            source={"DWD"}
            sourceLink={
              "https://wetterdienst.maps.arcgis.com/apps/dashboards/a490b2b390044ff0a8b8b4c51aa24c60"
            }
            infoLink={"https://www.ardalpha.de/klimazahlen-unwetter-100.html"}
            color={chartColors.pink}
            isAnimated={isAnimated}
          />
        </Group>
      </Group>
    </Svg>
  );
};
